<span class="spinner-border spinner-border-sm ms-3" role="status" aria-hidden="true"></span>